import { createFeatureSelector, createSelector } from '@ngrx/store';

import { mapFeatureKey, State } from '../reducers/map.reducer';

export const selectMapFeature = createFeatureSelector<State>(mapFeatureKey);

export const selectOptions = createSelector(selectMapFeature, (state: State) => state.options);

export const selectCurrentType = createSelector(selectMapFeature, (state: State) => state.currentMapType);

export const selectAvailableTypes = createSelector(selectMapFeature, (state: State) => state.availableMapTypeIds);

export const selectMarkerOptions = createSelector(selectMapFeature, (state: State) => state.markerOptions);

export const selectCenter = createSelector(selectMapFeature, (state: State) => state.center);

export const selectUserPosition = createSelector(selectMapFeature, (state: State) => state.userPosition);
